<template>
    <div class="footer2" v-if="state === 2">
        <div class="header">
            <span class="btn-title" @click="() => {isOpen = !isOpen}">솔닥 주식회사</span>
            <img v-if="!isOpen" @click="() => {isOpen = !isOpen}" class="icon" src="../../assets/bottom_arrow.png" />
            <img v-else class="icon" @click="() => {isOpen = !isOpen}" src="../../assets/top_arrow.png" />
        </div>
        <div v-if="isOpen" style="margin-top: 10px;">
            <span class="contents">
                서울 강남구 학동로33길 17, 3층)<br/> 사업자등록번호: 284-87-00967<br/> 통신판매업신고번호: 2021-서울강남-06329<br/> 대표자명: 김민승, 이호익<br/> 개인정보관리자: 김민승<br/> 대표번호: 02-6954-7682<br/> 이메일: info@soldoc.co.kr<br/> ©soldoc Co., Ltd. All Rights Reserved.<br/>
                {{version}}
            </span>
            <div style="margin-top: 16px;">
                <span class="link" @click="openPolicy(1)">이용약관</span><span class="link" @click="openPolicy(2)">개인정보처리방침</span><span class="link" @click="openPolicy(3)">위치기반서비스이용약관</span>
            </div>
        </div>
        <div v-else>

        </div>   
    </div>
    <div class="footer" v-else>
        <div class="header">
            <span class="btn-title" @click="() => {isOpen = !isOpen}">솔닥 주식회사</span>
            <img v-if="!isOpen" @click="() => {isOpen = !isOpen}" class="icon" src="../../assets/bottom_arrow.png" />
            <img v-else class="icon" @click="() => {isOpen = !isOpen}" src="../../assets/top_arrow.png" />
        </div>
        <div v-if="isOpen" style="margin-top: 10px;">
            <span class="contents">
                서울 강남구 학동로33길 17, 3층<br/> 사업자등록번호: 284-87-00967<br/> 통신판매업신고번호: 2021-서울강남-06329<br/> 대표자명: 김민승, 이호익<br/> 개인정보관리자: 김민승<br/> 대표번호: 02-6954-7682<br/> 이메일: info@soldoc.co.kr<br/> ©soldoc Co., Ltd. All Rights Reserved.<br/>
                {{version}}
            </span>
            <div style="margin-top: 16px;">
                <span class="link" @click="openPolicy(1)">이용약관</span><span class="link" @click="openPolicy(2)">개인정보처리방침</span><span class="link" @click="openPolicy(3)">위치기반서비스이용약관</span>
            </div>
        </div>
        <div v-else>

        </div>
    </div>
    
</template>

<script>
export default {
    name: 'pageFooter',
    data: function()
    {
        return {
            isOpen: false,
            version: 'v.1.45.11'
        }
    },
    props: ['state'],
    methods: {
        openPolicy: function(index)
        {   
            if(index === 1)
            {
                window.open("https://policy.soldoc.co.kr/terms", '_blank')
            }
            else if(index === 2)
            {
                window.open("https://policy.soldoc.co.kr/privacy", '_blank')
            }
            else if(index === 3)
            {
                window.open("https://policy.soldoc.co.kr/location", '_blank')
            }
            else if(index === 4)
            {
                window.open("https://policy.soldoc.co.kr/marketing", '_blank')
            }
        }
    }
}
</script>

<style scoped>

    .footer {
        width: 100%;
        /* background: var(--Gray-20, #F3F5F8); */
        padding: 20px 0;
    }
    .footer2 {
        width: 100%;
        background: var(--Gray-20, #F3F5F8);
        padding: 20px 0;
    }
    .icon{
        width: 16px;
        margin-left: 11px;
    }
    .btn-title {
        color: var(--sub-color-3, #A3AAB6);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px; /* 133.333% */
    }
    .header {
        cursor: pointer;
    }
    .contents {
        color: var(--sub-color-3, #A3AAB6);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px; /* 133.333% */
    }
    .link {
        color: var(--sub-color-3, #A3AAB6);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px; /* 133.333% */
        text-decoration-line: underline;
        margin-right: 16px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/PageFooter.vue